export default __webpack_public_path__ + "static/ransnet-bfdf1d0fb9cddf98c9fe58eab293fc44.jpg";